// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SetupFctCredentialsHereLink: 'setup-fct-credentials-here-link',
	Link: 'link',
	BackToFileButton: 'back-to-file-button',
	CloseButton: 'close-button',
	RetryButton: 'retry-button',
	RetryButton1: 'retry-button-1',
	LoadingIcon: 'loading-icon',
	WarningIcon: 'warning-icon',
	WarningIcon1: 'warning-icon-1',
	ErrorIcon: 'error-icon',
	MatterTypeIcon: 'matter-type-icon',
	LLCiFrame: 'll-ci-frame',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
